import { render, staticRenderFns } from "./PictureHeader.vue?vue&type=template&id=85b681ac&scoped=true&"
import script from "./PictureHeader.vue?vue&type=script&lang=js&"
export * from "./PictureHeader.vue?vue&type=script&lang=js&"
import style0 from "./PictureHeader.vue?vue&type=style&index=0&id=85b681ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b681ac",
  null
  
)

export default component.exports